// @flow
import React from "react";
import { Box, Heading, Container, Text } from "rebass";
import styled from "styled-components";

type Props = {
  heading?: string
};

const Connect = (props: Props) => (
  <WrapBox {...props}>
    <Container>
      <Heading
        center
        mb={[4, 4, 5]}
        f={[3, 3, 4, 5]}
        px={[2]}
        color="support2"
        className="font-light"
      >
        {props.heading}
      </Heading>

      <Plugin className="fb-plugin">
        <div
          className="fb-messengermessageus"
          messenger_app_id="137853846788998"
          page_id="227754084405138"
          data-color="blue"
          data-size="xlarge"
        />
      </Plugin>

      <Email f={[1]} color="gray3">
        team [at] pipeline.social
      </Email>
    </Container>
  </WrapBox>
);

Connect.defaultProps = {
  heading: "Still not ready? Chat with us to get your questions answered"
};

export default Connect;

// Styled Components
const Plugin = styled.div`
  text-align: center;
`;

const Email = styled(Text)`
  text-align: center;

  .facebook-loaded & {
    display: none;
  }
`;

const WrapBox = styled(Box)`
  position: relative;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/Connect.jsx